<template>
  <div class="main">
    <toptab></toptab>
    <baidu-map
      class="bm-view"
      ak="YOUR_APP_KEY"
      :center="center"
      :zoom="zoom"
      @ready="handler"
      :scroll-wheel-zoom="true"
    >
      <bm-marker
        v-for="(item, index) in detail"
        :key="index"
        :position="{ lng: item.lng, lat: item.lat }"
        :dragging="true"
      ></bm-marker>
      <bm-overlay
        v-for="(item, index) in detail"
        :key="index"
        pane="labelPane"
        :class="{ sample: true }"
        @draw="drawMap($event, item)"
      >
        <div>{{ item.address }}</div>
      </bm-overlay>
    </baidu-map>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div>
          <template v-for="(item, index) in detail">
            <div :key="index" style="margin-bottom: 0.7rem">
              <div class="maintitle animated fadeInUp">
                <b>{{ item.name }}</b>
              </div>
              <div class="maininfo animated fadeInUp">
                <div>
                  <span class="zyjm-zuoji1 aaaa"></span>
                  <b>座机:</b>
                  <span class="ccc">{{ item.tel }}</span>
                </div>
              </div>
              <div class="maininfo animated fadeInUp">
                <div>
                  <span class="zyjm-dianhua aaaa"></span>
                  <b>手机:</b>
                  <span class="ccc">{{ item.phone }}</span>
                </div>
              </div>
              <div class="maininfo animated fadeInUp">
                <div>
                  <span class="zyjm-youjian aaaa"></span>
                  <b>邮箱:</b>
                  <span class="ccc">{{ item.email }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="inputlist four">
          <input class="inputitem" placeholder="* 姓名" @change="onInput($event, 'name')" v-model="name" />
          <input class="inputitem" placeholder="* 联系方式" @change="onInput($event, 'tel')" v-model="tel" />
        </div>
        <div class="inputlist five">
          <input
            class="inputitem"
            placeholder="公司名称"
            @change="onInput($event, 'company_name')"
            v-model="company_name"
          />
          <input class="inputitem" placeholder="邮箱" @change="onInput($event, 'email')" v-model="email" />
        </div>
        <div class="inputlist six">
          <input
            class="longinputitem"
            placeholder="公司地址"
            @change="onInput($event, 'company_address')"
            v-model="company_address"
          />
        </div>
        <div class="inputlist seven">
          <textarea
            class="longinputitem"
            v-model="leave_message"
            placeholder="留言"
            @input="onInput($event, 'leave_message')"
          ></textarea>
        </div>
        <div class="morebtn eight">
          <a href="javascript:void(0);">
            <img src="../../static/contentbtn.png" alt @click="onSubmit" />
          </a>
        </div>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import footeritem from "../components/footer-item";
export default {
  components: {
    toptab,
    footeritem,
  },
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
      detail: [],
      name: "",
      tel: "",
      email: "",
      company_address: "",
      leave_message: "",
      company_name: "",
      mode: false,
      isSmall: false
    }
  },
  mounted() {
    this.loadData();
    this.$nextTick(() => {
      require('../../utils/contect');
    })
  },
  methods: {
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.center.lng = 120.7
      this.center.lat = 31.421
      this.zoom = 11
    },
    drawMap({ el, BMap, map }, item) {
      const pixel = map.pointToOverlayPixel(new BMap.Point(item.lng, item.lat))
      el.style.left = pixel.x - 143 + 'px'
      el.style.top = pixel.y - 66 + 'px'
    },
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.factories, {})
        .then(res => {
          console.log(res.data);
          let { error_code, factories } = res.data;
          if (error_code == 2001) {
            factories.forEach(v => {
              let local = v.lat_lon.split(",");
              v.lng = local[0]
              v.lat = local[1]
            })
            this.detail = factories

          }
        });
    },
    /**
     * 输入
     */
    onInput(e, id) {
      // console.log(e, id);
      // this[id] = e
    },
    // 提交
    onSubmit() {
      let { name, tel, email, company_address, leave_message, company_name, mode } = this
      if (mode) {
        return
      }
      if (!name) {
        this.err1();
        return
      }
      if (tel) {
        if (!(/^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/.test(tel))) {
          this.err2();
          return
        }
      } else {
        this.err3();
        return
      }
      if (email) {
        if (!(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/.test(email))) {
          this.err4();
          return
        }
      }
      this.moade = true
      this.$axios.post(this.$url.contactUs, { name, tel, email, company_address, leave_message, company_name })
        .then(res => {
          console.log(res.data);
          let { error_code } = res.data;
          if (error_code == 2001) {
            this.success()
            this.moade = false
          }
        })
        .catch(() => {
          this.moade = false
        })
    },
    err1() {
      // this.$message.error('必填参数为空');
      this.$message({
        message: '请填写您的姓名',
        type: 'error',
        iconClass: "__",
        customClass: "el-message--error",
        // duration: 0
      });
    },
    err2() {
      // this.$message.error('手机号格式错误');
      this.$message({
        message: '手机号格式错误',
        type: 'error',
        iconClass: "__",
        customClass: "el-message--error"
      });
    },
    err3() {
      // this.$message.error('必填参数为空');
      this.$message({
        message: '请填写您的手机号',
        type: 'error',
        iconClass: "__",
        customClass: "el-message--error"
      });
    },
    err4() {
      // this.$message.error('必填参数为空');
      this.$message({
        message: '邮箱格式错误',
        type: 'error',
        iconClass: "__",
        customClass: "el-message--error"
      });
    },
    err5() {
      // this.$message.error('必填参数为空');
      this.$message({
        message: '请先填写信息',
        type: 'error',
        iconClass: "__",
        customClass: "el-message--error"
      });
    },
    success() {
      this.$message({
        message: '提交成功',
        type: 'success',
        iconClass: "__",
        customClass: "el-message--success"
      });
    },
  }
}
</script>
<style>
.el-message__content {
  padding: 0;
  font-size: 40px;
  line-height: 2;
  text-align: center;
  width: 100%;
}

.el-message {
  min-width: 900px;
}
</style>
<style scoped>
@import "../css/padding.css";
@import "../css/animate.min.css";

.main {
  padding-top: 0.67rem;
}

.bm-view {
  width: 100%;
  height: 538px;
}

.mainouter {
  width: 100%;
  /* padding: 1rem 0; */
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.whiteback {
  background-color: #fff;
}

.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}
.maintitle {
  font-size: 0.4rem;
  /* height: 0.4rem; */
  border-left: 4px solid #ff6900;
  line-height: 0.4rem;
  padding-left: 0.1rem;
  margin: 0.4rem 0;
}
.maininfo {
  display: flex;
  justify-content: baseline;
  font-size: 0.25rem;
  margin: 0.2rem 0;
  /* line-height: 0.3rem; */
}
.aaaa {
  color: #ff6900;
  line-height: 0.3rem;
}
.bbb {
  line-height: 0.3rem;
}
.ccc {
  color: #616161;
  line-height: 0.3rem;
  margin-left: 10px;
}
.mainheight {
  height: 0.4rem;
}
.inputlist {
  display: flex;
  justify-content: space-between;
  margin: 0.2rem 0;
}
.shortinputitem {
  /* width: 100%;
  max-width: 44%;
  background-color: #f5f5f5;
  padding: 0.1rem 0.3rem;
  color: #989898;
  position: relative;
  height: 0.8rem; */
}
.mustinput {
  position: absolute;
  top: 0;
  font-size: 0.06rem;
}
.inputitem {
  font-size: 0.16rem;
  border: none;
  background-color: #f5f5f5;
  padding: 0.1rem 0.3rem;
  width: 100%;
  max-width: 48%;
  outline: none;
}
.longinputitem {
  font-size: 0.16rem;
  border: none;
  background-color: #f5f5f5;
  padding: 0.1rem 0.3rem;
  width: 100%;
  outline: none;
}

.morebtn {
  display: flex;
  justify-content: center;
}
.morebtn img {
  width: 2rem;
}

.sample {
  width: 286px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 105, 0, 0.8);
  overflow: hidden;
  /* box-shadow: 0 0 5px #000; */
  color: #fff;
  text-align: center;
  /* padding: 10px; */
  position: absolute;
  font-size: 0.14rem;
  /* top: -40px !important;
  left: -100px !important; */
}
/* .sample.active {
  background: rgba(255, 105, 0, 0.75);
  color: #fff;
} */
/* .inputitem input:focus {
  outline: medium;
} */
@media (max-width: 1440px) {
  .firstinfo {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .main {
    padding-top: 100px;
  }
  .morebtn img {
    width: 3rem;
  }

  .maintitle {
    font-size: 60px;
    /* height: 0.4rem; */
    border-left: 4px solid #ff6900;
    line-height: 70px;
    padding-left: 0.1rem;
    margin: 0.4rem 0;
  }

  .maininfo {
    display: flex;
    justify-content: baseline;
    font-size: 40px;
    margin: 0.2rem 0;
    /* line-height: 0.3rem; */
  }

  .inputitem {
    font-size: 40px;
    border: none;
    background-color: #f5f5f5;
    padding: 20px;
    width: 100%;
    max-width: 48%;
    outline: none;
  }

  .longinputitem {
    font-size: 40px;
    border: none;
    background-color: #f5f5f5;
    padding: 20px;
    width: 100%;
    outline: none;
  }

  /* .sample {
    width: 600px;
    height: 60px;
    line-height: 60px;
    background: rgba(255, 105, 0, 0.8);
    overflow: hidden;
    color: #fff;
    text-align: center;
    position: absolute;
    font-size: 30px;
  } */
}
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue